(function(){
  var MQ = 999;
  function isMobile(){ return window.innerWidth <= MQ; }
  var L = 'M15 5l-7 7 7 7', R = 'M9 5l7 7-7 7';
  function icon(d){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; }

  function makeRail(track){
    if(!track || track.getAttribute('data-mrail')) return;
    if(track.children.length < 2) return;
    track.setAttribute('data-mrail','1');
    track.classList.add('m-rail');
    var wrap = document.createElement('div');
    wrap.className = 'm-railwrap';
    track.parentNode.insertBefore(wrap, track);
    var bar = document.createElement('div');
    bar.className = 'm-arrows';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'm-arrow'; prev.setAttribute('aria-label','Previous'); prev.innerHTML = icon(L);
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'm-arrow'; next.setAttribute('aria-label','Next'); next.innerHTML = icon(R);
    bar.appendChild(prev); bar.appendChild(next);
    wrap.appendChild(bar); wrap.appendChild(track);

    // step = width of one card plus the gap, measured live so it stays
    // correct when the viewport changes or the device rotates
    function step(){
      var a = track.children[0];
      if(!a) return Math.round(track.clientWidth * 0.9);
      var w = a.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '12') || 12;
      return Math.round(w + gap);
    }
    function go(dir){
      if(track.scrollBy){ track.scrollBy({left: dir * step(), behavior: 'smooth'}); }
      else { track.scrollLeft += dir * step(); }
    }
    prev.addEventListener('click', function(){ go(-1); });
    next.addEventListener('click', function(){ go(1); });
    function state(){
      prev.disabled = track.scrollLeft < 6;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 6;
    }
    track.addEventListener('scroll', state, {passive: true});
    window.addEventListener('resize', state);
    window.addEventListener('orientationchange', function(){ setTimeout(state, 250); });
    state();
  }

  function footerAccordion(){
    var items = document.querySelectorAll('.site-footer .footer__item--menu, .site-footer .footer__item--text');
    for(var i = 0; i < items.length; i++){
      var it = items[i];
      if(it.getAttribute('data-macc')) continue;
      var t = it.querySelector('.footer__title');
      if(!t) continue;
      it.setAttribute('data-macc','1');
      it.classList.add('m-acc');
      t.setAttribute('role','button');
      t.setAttribute('tabindex','0');
      (function(item, title){
        function toggle(){ item.classList.toggle('is-open'); }
        title.addEventListener('click', toggle);
        title.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); }
        });
      })(it, t);
    }
  }

  function build(){
    makeRail(document.querySelector('.reviews--grid .reviews__grid'));
    var fbs = document.querySelectorAll('.featured-blocks');
    for(var i = 0; i < fbs.length; i++){ makeRail(fbs[i]); }
    var st = document.querySelectorAll('.pstats__grid');
    for(var j = 0; j < st.length; j++){ makeRail(st[j]); }
    footerAccordion();
  }

  function init(){
    if(isMobile()) build();
  }

  // if the window is resized or the device rotated down into the mobile
  // range after load, build then. Above 999 the rail CSS simply does not
  // apply, so nothing needs tearing down.
  var t;
  window.addEventListener('resize', function(){
    clearTimeout(t);
    t = setTimeout(init, 200);
  });
  window.addEventListener('orientationchange', function(){ setTimeout(init, 300); });

  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
